import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCardBg = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 366,
	height: 82,
	viewBox: "0 0 366 82",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M0 32C0 16.9151 0 9.37258 4.68629 4.68629C9.37258 0 16.9151 0 32 0H334C349.085 0 356.627 0 361.314 4.68629C366 9.37258 366 16.9151 366 32V50C366 65.0849 366 72.6274 361.314 77.3137C356.627 82 349.085 82 334 82H32C16.9151 82 9.37258 82 4.68629 77.3137C0 72.6274 0 65.0849 0 50V32Z",
		fill: "white"
	})
});
export default SvgCardBg;
